export default __webpack_public_path__ + "static/media/romaina.8a50a150.svg";